import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import * as DateFns from 'date-fns';
import { Link } from 'react-router-dom';

import Navbar from '../Navbar/NavBar';
import {
  CONTROLLER_SET,
  FILTER_GLOBAL_KEYS,
  FILTER_KEYS,
  SIMPLE_LEAGUE
} from '../../config/constants';
import Table, { RowsType } from '../Shared/CustomTable';
import SimpleMultiSelector from '../Shared/Filters/SimpleMultiSelector';
import SimpleSelector from '../Shared/Filters/SimpleSelector';
import { YearSeasonFilter } from '../Shared/Filters/YearSeasonFilter/YearSeasonFilter';
import TeamSelectorContainer from '../Shared/Filters/TeamsSelector';
import {
  buildIntensityFilter,
  cleanControllerSet,
  fixDecimals,
  getFile,
  getTeamData,
  isCC,
  isJson,
  isNCAA,
  isNCAAAllSports,
  msToTime,
  paramBuilder,
  saveDataEventsOnLocalStorage,
  text_truncate
} from '../../helpers';
import Loader from '../Shared/Loader';
import { SERVER } from '../../config/server.config';
import ConfirmationModal from '../Shared/Modals/ConfirmationModal';
import { useRouter } from '../../helpers/customHooks';
import {
  selectIntensitiesByTeam,
  useFiltersState,
  usePracticesDispatch,
  usePracticesState,
  useTablePropertiesState,
  useUserState
} from '../../store/hooks';
import { history } from '../../store/reducers';
import { message, notification } from 'antd';
import './modal.scss';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { useSelector } from 'react-redux';

const defaultTable = { orderColumn: 2 };

export const Practices = () => {
  
  const { specificScope, pathname, search } = useRouter();
  const user = useUserState();
  const {
    [FILTER_KEYS.INTENSITY]: filterIntensityData,
    [FILTER_KEYS.TEAM_ID]: filterTeamIdData,
    [FILTER_KEYS.DATE_RANGE]: filterDateRangeData,
    [FILTER_GLOBAL_KEYS.WEEKS]: weeks
  } = useFiltersState(specificScope, FILTER_KEYS.INTENSITY, FILTER_KEYS.TEAM_ID, FILTER_KEYS.DATE_RANGE, FILTER_GLOBAL_KEYS.WEEKS);
  const practices = usePracticesState();
  const { tableProperties } = useTablePropertiesState();
  const { loadPractices } = usePracticesDispatch();
  const{ download } = useFlagsState();
  const {  fileIsDownloading } = useFlagsDispatch();
    const intensities = useSelector(
  selectIntensitiesByTeam(isCC(user)?filterTeamIdData!!: user.teamId)
);
  const intensityFilter = buildIntensityFilter(intensities?? []);

  useEffect(() => {
    saveDataEventsOnLocalStorage(practices.map((practice) => practice.dsid));
  }, [practices]);
  
useEffect(() => {
  const timeout = setTimeout(() => {
    if (
      weeks &&
      filterIntensityData &&
      (((isCC(user) || isNCAAAllSports(user)) && filterTeamIdData) ||
        !(isCC(user) || isNCAAAllSports(user))) &&
      filterDateRangeData?.selectedDates?.length
    ) {
      loadPractices(true)();
    }
  }, 30);
  return () => clearTimeout(timeout);
}, [weeks, filterIntensityData, filterDateRangeData, filterTeamIdData]);

   // Exports Notification
   const notificationKey = 'downloadFinished';
   const notificationDownload = (name:string) => {
     const args = {
       key: notificationKey,
       message: 'Download In Progress',
       description:
         `Your file ${name} is being processed.`,
       duration: 0,
       icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
     };
     notification.open(args);
   };
   const notificationDownloadFinish = (name:string) => {
     const args = {
       key: notificationKey,
       message: 'Download Finished',
       description: `Your file ${name} has been downloaded successfully.`,
       duration: 4,
       icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
     };
     notification.open(args);
   };
   const notificationDownloadError = (name:string) => {
     const args = {
       key: notificationKey,
       message: `Error downloading file ${name}`,
       duration: 4,
       icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
     };
     notification.open(args);
   };
  
  const [modal, setModal] = useState<null | JSX.Element>(null);
  const headers = [
    { content: 'NAME', style: { width: '143px', paddingLeft: '20px' }, isOrderly: true, leftSortIcon: '27px' },
    { content: 'DATE/TIME', style: { width: '146px' }, isOrderly: true, leftSortIcon: '27px' },
    { content: '# OF PERIODS', style: { width: '100px' }, isOrderly: true, leftSortIcon: '3px' },
    { content: 'DURATION', style: { width: '100px' }, isOrderly: true, leftSortIcon: '17px' },
    { content: 'INTENSITY', style: { width: '76px' }, isOrderly: true },
    {
      content: 'AVG. MAX SPEED',
      style: { width: '98px', paddingLeft: '36px' },
      class: 'll-pp',
      isOrderly: true,
      leftSortIcon: '68px'
    },
    {
      content: 'AVG. MAX SUST. SPEED',
      style: { width: '98px', paddingLeft: '36px' },
      class: 'll-pp',
      isOrderly: true,
      leftSortIcon: '68px'
    },
    {
      content: <>&nbsp;&nbsp;&nbsp;AVG.&nbsp;TTL. DIST.</>,
      style: { width: '88px' },
      class: 'll-pp',
      isOrderly: true,
      leftSortIcon: '57px'
    },
    { content: 'AVG. ACCEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true, leftSortIcon: '25px' },
    { content: 'AVG. DECEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true, leftSortIcon: '25px' },
    { style: { width: '323px' } }
  ];
  
  const rows: RowsType<string, number> = [];
  practices.forEach((practice, index) => {
    if (!practice.name && !practice.dsid && !practice.startTime) {
      return;
    }
    let selectedPractices = [];
    let found: boolean;
    if (tableProperties && tableProperties.selectedRows) {
      selectedPractices = tableProperties.selectedRows;
      found = !!selectedPractices.find(element => element === practice.dsid);
    }
    rows.push({
      columns: [
        {
          content: practice.name,
          print: (content: string) => (
            <Link
              to={{
                pathname: `/view/practice/${practice.dsid}/performance/expanded/page`,
                state: {
                  toReturn: pathname,
                  toReturnSearch: search
                }
              }}
              onClick={() => {
                cleanControllerSet(CONTROLLER_SET);
                //cleanArrayControllers(PRACTICES_PAGE_CONTROLLERS);
              }}
            >
              <label title={content} className="l-c" style={{ cursor: 'pointer' }}>
                <b> {text_truncate(content, 18)}</b>
              </label>
            </Link>
          ),
          order: (contentA: string, contentB: string) => contentA.localeCompare(contentB),
          style: { cursor: 'pointer', paddingLeft: '20px' }
        },
        {
          content: practice.startTime,
          print: (content: number) => (
            <label className="l-c">{DateFns.format(new Date(content), 'MM/dd/yyyy, h:mma')}</label>
          ),
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          content: practice.sessionNumber,
          print: (content: number) => <label className="l-c">{content}</label>,
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          content: Math.max(0, practice.endTime - practice.startTime),
          print: (content: number) => <label className="l-c">{msToTime(content)}</label>,
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          content: text_truncate(practice.intensity, 10),
          print: (content: string) => <label className="l-c">{content}</label>,
          order: (contentA: string, contentB: string) => contentA.localeCompare(contentB)
        },
        {
          class: 'll-pp',
          content: practice.aveMaxSpeedMPH,
          print: (content: number) => (<label className="l-c">{fixDecimals(content, 1)}</label>),
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          class: 'll-pp',
          content: practice.aveMaxSustainedSpeedMPH,
          print: (content: number) => <label className="l-c">{fixDecimals(content, 1)}</label>,
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          class: 'll-pp',
          content: practice.totalAveDist,
          print: (content: number) => <label className="l-c">{fixDecimals(content, 0)}</label>,
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          class: 'll-pp',
          content: fixDecimals(practice.totalAveAccels, 0),
          print: (content: string) => (
            <label className="l-c">{!Number.isNaN(+content) && +content !== -1 ? content : '-'}</label>
          ),
          order: (contentA: string, contentB: string) => +contentA - +contentB
        },
        {
          class: 'll-pp',
          content: fixDecimals(practice.totalAveDecels, 0),
          print: (content: string) => (
            <label className="l-c">{!Number.isNaN(+content) && +content !== -1 ? content : '-'}</label>
          ),
          order: (contentA: string, contentB: string) => +contentA - +contentB
        },
        {
          class: 'oo-u',
          print: () => (
            <>
              <Button
                disabled={download}
                className="btn-blue"
                style={{
                  opacity: (found) ? '1' : '',
                  visibility: (found && selectedPractices.length >= 2) ? 'hidden' : 'visible'
                }}
                onClick={async () => {
                  fileIsDownloading(true);
                  notificationDownload(`${practice.dsid}.csv`);
                  const done = await getFile(SERVER.CSV_REPORT(practice.dsid) + 
                  paramBuilder({ tzOffset: -(new Date(practice.startTime).getTimezoneOffset()), teamId: practice.homeTeamId }), 
                  `${practice.dsid}.csv`);
                  if (done) {
                    fileIsDownloading(false);
                    notificationDownloadFinish(`${practice.dsid}.csv`);
                  } else {
                    fileIsDownloading(false);
                    notificationDownloadError(`${practice.dsid}.csv`);
                  }
                  setTimeout(() => setModal(null), 5000);
                }}
              >
                Export
              </Button>
              <Link
                to={{
                  pathname: `/view/practice/${practice.dsid}/performance/expanded/page`,
                  state: { toReturn: pathname, toReturnSearch: search }
                }}
                onClick={() => {
                  cleanControllerSet(CONTROLLER_SET);
                }}
              >
                <Button
                  className="btn-blue"
                  style={{
                    opacity: (found) ? '1' : '',
                    visibility: (found && selectedPractices.length >= 2) ? 'hidden' : 'visible',
                    marginRight: '10px'
                  }}
                >
                  View Full Practice Data
                </Button>
              </Link>
            </>)
        }
      ],
      id: practice.gameId+index
    });
  });
  
  const [showFilter, setShowFilter] = useState(-1);
  const close = () => setShowFilter(-1);

  return (
    <>
      {modal}
      <Navbar />
      <Container className="container-00 gg-01">
        <h4 className="h-t">Practices</h4>
        <Row>
          <Col lg={12} xs={12}>
            <div className="head-filters-01">
              {isCC(user) && (
                <SimpleSelector
                  show={showFilter === 0}
                  close={close}
                  open={() => setShowFilter(0)}
                  type={SIMPLE_LEAGUE}
                  urlPersistent
                />
              )}
              {(isCC(user) || isNCAAAllSports(user)) && (
                <TeamSelectorContainer
                  show={showFilter === 1}
                  close={close}
                  open={() => setShowFilter(1)}
                  onApply={(nextTeam, prevTeam) => {
                    const teamA = getTeamData(nextTeam);
                    const teamB = getTeamData(prevTeam);
                    if (teamB && teamA && teamB.isNCAA !== teamA.isNCAA) {
                      const urlSearchParams = new URLSearchParams(search);
                      urlSearchParams.delete(FILTER_KEYS.DATE_RANGE);
                      urlSearchParams.set(FILTER_KEYS.TEAM_ID, nextTeam);
                      history.push({ pathname: pathname, search: `?${urlSearchParams.toString()}` });
                      
                    }
                  }}
                  urlPersistent
                />
              )}
              <YearSeasonFilter
                show={showFilter === 4}
                close={close}
                open={() => setShowFilter(4)}
                isNcaa={!!(isNCAAAllSports(user) || isNCAA(user))}
                urlPersistent
              />
              <SimpleMultiSelector
                type={intensityFilter}
                show={showFilter === 3}
                close={close}
                open={() => setShowFilter(3)}
                isCustomIntensity={true}
                teamId={filterTeamIdData}
              />
            </div>
            <div className="practice-cc practice-cc-width">
              <Loader forceLoader={!weeks}>
                <Table
                  headers={headers}
                  rows={rows}
                  default={defaultTable}
                  isSelectedStyle
                />
              </Loader>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Practices;
